<template>
  <div class="news-center">
    <main class="news-center-main">
      <img loading="lazy" class="main-bg" src="@/assets/img/newsCenter/1.png" alt="">
      <div class="wr-news">
        <div class="title">{{ '沃瑞新闻' }}</div>
        <div class="news-container">
          <div>
            <div v-for="item in wrNewsList1" :key="item.id" class="news-item" @click="toDetails(item)">
              <div class="item">
                <img loading="lazy" class="item-icon" src="@/assets/img/newsCenter/2.png" alt="">
                <span class="news-title">{{ item.title }}</span>
                <span class="publish-time ellipsis ">{{ moment(item.publishTime).format('YYYY-MM-DD') }}</span>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div>
            <div v-for="item in wrNewsList2" :key="item.id" class="news-item" @click="toDetails(item)">
              <div class="item">
                <img loading="lazy" class="item-icon" src="@/assets/img/newsCenter/2.png" alt="">
                <span class="news-title">{{ item.title }}</span>
                <span class="publish-time ellipsis">{{ moment(item.publishTime).format('YYYY-MM-DD') }}</span>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
          <el-pagination background layout="prev, pager, next" :total="wrNewsTotal"
            @current-change="handleChange($event, '沃瑞新闻')">
          </el-pagination>
        </div>
      </div>
      <div class="industry-news">
        <div class="title">{{ '行业新闻' }}</div>
        <div class="news-container">
          <div>
            <div v-for="item in industryNewsList1" :key="item.id" class="news-item" @click="toDetails(item)">
              <div class="item">
                <img loading="lazy" class="item-icon" src="@/assets/img/newsCenter/3.png" alt="">
                <span class="news-title">{{ item.title }}</span>
                <span class="publish-time ellipsis">{{ moment(item.publishTime).format('YYYY-MM-DD') }}</span>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div>
            <div v-for="item in industryNewsList2" :key="item.id" class="news-item" @click="toDetails(item)">
              <div class="item">
                <img loading="lazy" class="item-icon" src="@/assets/img/newsCenter/3.png" alt="">
                <span class="news-title">{{ item.title }}</span>
                <span class="publish-time ellipsis">{{ moment(item.publishTime).format('YYYY-MM-DD') }}</span>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
          <el-pagination background layout="prev, pager, next" :total="industryNewsTotal"
            @current-change="handleChange($event, '行业新闻')"></el-pagination>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer/index'
import moment from 'moment'
export default {
  name: '',
  components: {
    Footer,
  },
  props: [],
  data() {
    return {
      moment,
      wrNewsList1: [],
      wrNewsList2: [],
      industryNewsList1: [],
      industryNewsList2: [],
      wrQueryInfo: {
        pageSize: 10,
        pageNum: 1,
        category: '沃瑞新闻'
      },
      industryQueryInfo: {
        pageSize: 10,
        pageNum: 1,
        category: '行业新闻'
      },
      details: {},
      isDetails: false,
      wrNewsTotal: 0,
      industryNewsTotal: 0,
    }
  },
  created() {
    this.getWRNewsData()
    this.getIndustryNewsData()
  },
  mounted() {

  },
  methods: {

    handleChange(e, type) {
      if (type == '沃瑞新闻') {
        this.wrQueryInfo.pageNum = e
        this.getWRNewsData()
      } else {
        this.industryQueryInfo.pageNum = e
        this.getIndustryNewsData()
      }
    },
    getWRNewsData() {
      this.$apis.news_list(this.wrQueryInfo).then(res => {
        let wrNewsList = res.data.records
        this.wrNewsList1 = wrNewsList.filter((item, index) => index % 2 == 0)
        this.wrNewsList2 = wrNewsList.filter((item, index) => index % 2 == 1)
        this.wrNewsTotal = Number(res.data.total)
      })
    },
    getIndustryNewsData() {
      this.$apis.news_list(this.industryQueryInfo).then(res => {
        let industryNewsList = res.data.records
        this.industryNewsList1 = industryNewsList.filter((item, index) => index % 2 == 0)
        this.industryNewsList2 = industryNewsList.filter((item, index) => index % 2 == 1)
        this.industryNewsTotal = Number(res.data.total)
      })
    },
    toDetails(item) {
      this.$router.push({ name: `/newsDetails`, params: item })
    },
    getDividerHeight() {
    }
  },
}
</script>

<!-- 私有 -->

<style lang='scss' scoped>
.news-center {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .news-center-main {
    flex: 1;
    display: flex;
    flex-direction: column;


    .industry-news {
      flex: 1;
      margin-top: 50px;
      background: #F0F9FF;
      padding-bottom: 30px;
    }
  }
}
</style>

<!-- 共有 -->

<style lang='scss' scoped>
.news-center {
  .news-center-main {

    .wr-news,
    .industry-news {
      display: grid;
      justify-content: center;
      text-align: left;
      grid-template-rows: 3.75rem 1fr;

      .title {
        font-family: FZLanTingHei-H-GBK;
        font-weight: 600;
        font-size: 1.75rem;
        color: #81B1D7;
        font-style: italic;
        text-align: left;
        margin-top: 1.5rem;
        height: 2.3125rem;
        margin-left: -6.25rem;
      }

      .news-container {
        width: 68.75rem;
        min-width: 68.75rem;
        display: grid;
        grid-template-columns: 1fr 1px 1fr 50px;
        gap: 1.25rem;

        .news-item {
          display: flex;
          flex-direction: column;
          margin-top: 1.25rem;
          cursor: pointer;

          .el-divider--horizontal {
            margin: 6px 0 0 0;
            width: 100%;
            background-color: #f3e9e9;
          }

          .item {
            display: flex;

            .item-icon {
              width: 1.125rem;
              height: 1.125rem;
            }

            .news-title {
              margin-left: 0.625rem;
              font-family: FZLanTingHei-H-GBK;
              font-weight: 400;
              font-size: 1rem;
              color: #1A1A1A;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              white-space: nowrap;
              width: 23.125rem;
              display: block;

              &:hover {
                text-decoration: underline;
                color: #3d99e4;
              }
            }

            .publish-time {
              margin-left: auto;
              font-family: FZLanTingHei-R-GBK;
              font-weight: 400;
              font-size: 0.875rem;
              color: #666666;
            }
          }

        }

        .el-divider--vertical {
          margin: 23px 0 0 0;
          height: calc(100% - 20px);
          background-color: #f3e9e9;
        }
      }
    }

  }

}
</style>

<style></style>